import {dataset, on, off, fire, isOrHasParent, addClass, removeClass, find, findMany} from '../helpers'

// Defining a Dropdown class
export default class Dropdown {
    constructor(button) {
        // Initializing the initial state as false
        this._state = false

        // Storing the reference to the button element passed during instantiation
        this.button = button;

        // Finding the dropdown menu element based on the button's 'target' data attribute
        this.menu = find(`.${dataset(button, 'target')}`);

        // // Creating an element for the semi-transparent background (skrim)
        // this.skrim = document.createElement('div');

        // Finding multiple elements with class '.megamenu'
        this.megamenu = findMany('.megamenu');

        // Attaching event listeners and setting up initial configuration
        this.listen();
    }

    // Method to set up event listeners
    listen() {
        // Listening for window resize to close the dropdown
        on('resize', () => this.state = false, window)

        // Listening for custom event 'dropdown-opened' to close the dropdown
        on('dropdown-opened', () => this.state = false)

        on('dropdown-close', () => this.state = false)

        // Click event listener for the dropdown button
        this.button.addEventListener('click', event => {
            event.preventDefault()

            // Toggling the state of the dropdown
            this.state = !this.state
        })
    }

    // Setter method to control the state of the dropdown
    set state(state) {
        // Checking if the state is different from the current state
        if (state !== this._state) {
            if (state) {
                // Opening the dropdown
                this.open()
                // Firing a custom event 'dropdown-opened'
                fire('dropdown-opened')

                // Applying specific styles to elements after a delay
                setTimeout(() => {
                    this.megamenu.forEach(item => {
                        removeClass(item, ['-translate-y-4', 'opacity-0'])
                    })
                }, 0);

                // Adding the semi-transparent background
                this.addSkrim();

            } else {
                // Checking if any megamenu items are open
                this.isMenuOpen()

                // Closing the dropdown
                this.close()

                // Handling actions when closing the dropdown after a delay
                setTimeout(() => {
                    this.megamenu.forEach(item => {
                        addClass(item, ['-translate-y-4', 'opacity-0']);
                    })
                }, 0);

            }

            // Updating the state
            this._state = state
        }
    }

    // Getter method to retrieve the current state of the dropdown
    get state() {
        return this._state
    }

    // Method to open the dropdown
    open() {
        // Adding classes to the button and menu to show them
        addClass(this.button, 'is-active')
        removeClass(this.menu, 'hidden')

        // Applying further styles after a delay
        setTimeout(() => {
            addClass(this.menu, 'is-open')

            // Executing additional actions when the dropdown opens
            this.onOpen()

            // Listening for the escape key press
            on('keydown', this.escapeKey, window)

            // Listening for clicks on the document
            setTimeout(() => on('click', this.somethingClicked), 1)
        }, 0)
    }

    onOpen() {
        // ... overwrite this if you need.
    }

    // Method to close the dropdown
    close() {
        // Removing classes and detaching event listeners
        removeClass(this.button, 'is-active')
        removeClass(this.menu, 'is-open')
        off('keydown', this.escapeKey)
        setTimeout(() => off('click', this.somethingClicked), 1)
    }

    // Method to check if any megamenu items are open
    isMenuOpen() {
        setTimeout(() => {
            const isOpen = Array.from(this.megamenu).some(menu => menu.classList.contains('is-open'))

            if (!isOpen) {
                // Removing the semi-transparent background after delay
                this.removeSkrim()
                setTimeout(() => {
                    addClass(this.menu, 'hidden')
                }, 400)
            } else {
                this.addSkrim()
                setTimeout(() => {
                    addClass(this.menu, 'hidden')
                }, 1)
            }
        }, 0);
    }

    // Method to handle escape key press to close the dropdown
    escapeKey = event => {
        if (event.key === 'Escape' || event.keyCode === 27 || event.which === 27) {
            this.state = false
        }
    }

    // Method to handle clicks outside the dropdown to close it
    somethingClicked = ({ target }) => {
        if (!isOrHasParent(target, '.megamenu')) {
            this.state = false
        }
    }

    // Method to add the semi-transparent background
    addSkrim = () => {
        const skrimId = 'skrim';

        // Check if skrim element already exists
        let skrim = document.getElementById(skrimId);

        if (!skrim) {
            // Creating the skrim element if it doesn't exist
            skrim = document.createElement('div');
            skrim.setAttribute('id', skrimId);
            addClass(skrim, ['fixed', 'inset-0', 'bg-black/70', 'backdrop-blur-sm', 'z-10', 'transition', 'duration-300', 'ease-linear', 'opacity-0'])

            // Appending skrim to the body
            find('body').appendChild(skrim);

            // Fading in the skrim element after a delay
            setTimeout(() => {
                removeClass(skrim, 'opacity-0');
            }, 0);
        }
    }

    // Method to remove the semi-transparent background
    removeSkrim = () => {

        // Check if skrim element already exists
        const skrim = document.getElementById('skrim');

        if (skrim) {
            // Fading out the skrim element
            setTimeout(() => {
                addClass(skrim, 'opacity-0');
            }, 0);

            // Removing the skrim element after a delay
            setTimeout(() => {
                skrim.remove();
            }, 400);
        }
    }
}
